import { StoryblokServerComponent, storyblokEditable } from '@storyblok/react/rsc'
import Section from '@audioeye-marketing/ui/src/components/Section'
import Container from '@audioeye-marketing/ui/src/components/Container'
import Box from '@audioeye-marketing/ui/src/components/Box'
import ListItem from '@audioeye-marketing/ui/src/components/ListItem'
import Stack from '@audioeye-marketing/ui/src/components/Stack'
import colors from '@audioeye-marketing/ui/src/theme/colors'
import translateSectionStyles from '@/lib/translate-section-styles'

const SecondaryNavigation = ({ blok, rels, sx, padding }) => {
  const backgroundColor = blok?.dark ? colors.common.black : colors.neutral[50]
  const topBottomPadding = blok?.large_padding ? { xs: 6, sm: 8, md: 10, xl: 10 } : { xs: '0.25rem', lg: '0.25rem' }
  const sectionStyles = translateSectionStyles({ background_color: { value: backgroundColor } })

  return (
    <Section
      {...storyblokEditable(blok)}
      {...sectionStyles}
      padding={padding}
      sx={{
        paddingTop: topBottomPadding,
        paddingBottom: topBottomPadding,
        position: 'sticky',
        top: '0',
        zIndex: '999',
        borderBottom: '1px solid var(--joy-palette-divider)',
        ...sx,
      }}
      id={blok?.anchor?.[0]?.anchor_id}
    >
      <Container constraint="lg">
        <Stack
          direction="row"
          alignItems="center"
          component="nav"
          role="navigation"
          aria-label={blok?.aria_label || 'Sub Navigation'}
        >
          {/* listStyleType, paddingLeft, etc are to remove bullets and other ul styling */}
          <Box
            component="ul"
            sx={{
              listStyleType: 'none',
              paddingLeft: '0',
              marginTop: '0',
              marginBottom: '0',
              display: 'flex',
              width: '100%',
              flexWrap: 'wrap',
              alignItems: 'center',
              marginLeft: blok?.justify_content === 'space-between' ? {} : { xs: 0, sm: '-10px' },
              justifyContent:
                blok?.justify_content === 'space-between'
                  ? 'space-between'
                  : blok?.justify_content === 'end'
                    ? 'flex-end'
                    : 'flex-start',
            }}
          >
            {blok?.items?.map((currentItem, index) => {
              return (
                <ListItem
                  key={currentItem?._uid}
                  sx={{
                    padding: '0',
                    display: 'inline-block',
                    marginLeft:
                      blok?.justify_content === 'space-between' ? { xs: 0, sm: index === 0 ? '-10px' : 0 } : {},
                  }}
                >
                  <StoryblokServerComponent
                    blok={currentItem}
                    rels={rels}
                    backgroundColor={backgroundColor}
                    size="sm"
                    color={blok?.dark ? 'light' : 'neutral'}
                    variant="plain"
                  />
                </ListItem>
              )
            })}
          </Box>
        </Stack>
      </Container>
    </Section>
  )
}

export default SecondaryNavigation
